import { Box, Typography } from "@mui/material";
import { StyledArtItem } from "./ArtItem.styled";
import { Art } from "../../Models/Art";
import { SERVERURL } from "../../Globals/Constants";

type ArtItemProps = {
  artItem: Art;
  onClick: (artItem: Art) => void;
};

export const ArtItemComponent = ({ artItem, onClick }: ArtItemProps) => {

  return (
    <StyledArtItem onClick={() => onClick(artItem)}>
      <Box className="imageWrapper">
        <img src={`${SERVERURL}${artItem.mainImage.filePath}`} alt={artItem.title}/>
      </Box>
      <Typography variant="h3">{artItem.title}</Typography>
      <Typography variant="h4">{artItem.description}</Typography>
      <Typography variant="h4">{artItem.sellState}</Typography>
    </StyledArtItem>
  );
};
